import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { useToggle } from '@codex/helpers';

import ProductPopup from './ProductPopup';
import ProductAvailability from './ProductAvailability';

import UILocale from '../../../../utils/UILocale';


const Product = (props) => {
  const [open, togglePopup] = useToggle();

  return (
    <article
      className={'product'}
      onClick={(e) => {
        e.preventDefault();
        togglePopup(!open);
      }}
    >
      <a
        href={`#db-prd-${props.sProductId}`}
        className={'popInTrigger productLink'}
        title={props.sLabel}
      >
        <img
          className={'bundleImg'}
          src={props.isMobile
            ? props.sImageUrl : props.sImageBigUrl}
          alt={''}
        />
        <div className={'desc'}>
          <header className={'productTitle'}>
            {props.sFullLabel}
          </header>
          {props.sComplementaryLabel !== '' && (
            <ul className={'productDescription'}>
              {props.sComplementaryLabel.split(', ', 3).map((description) => (
                <li key={description}>{description}</li>
              ))}
            </ul>
          )}
          <div className={'productPrices'}>
            {props.bIsDiscount && (
              <>
                <span className={'previousPrice'}>
                  {UILocale.getString('dynamic.bundles.bundle_normal_price')}
                  {' '}
                  <del>{props.sSeparatePrice}</del>
                </span>
                <br />
              </>
            )}
            <>
              <span className={'currentPrice'}>
                <ins>{props.sPrice}</ins>
              </span>
              <br />
            </>
            {props.bIsDiscount && (
              <>
                <small>
                  {UILocale.getString('dynamic.bundles.bundle_when_bought_with')}
                </small>
                <span className={'offerSaving inlineOffer'}>
                  {UILocale.getString('dynamic.bundles.save')}
                  {' '}
                  {props.sDiscount}
                </span>
              </>
            )}
          </div>
          <ProductAvailability {...props} />
        </div>
      </a>

      {open && (
        <ProductPopup
          {...props}
          onClose={() => { togglePopup(false); }}
        />
      )}

      <span id={`addAccessory${props.sProductId}`} className={'addAccesorryButton'}>
        <button
          name={'add'}
          className={`bt btn-primary outline pt10 ${props.addButtonDisabled ? 'btn-disabled' : ''}`}
          disabled={props.addButtonDisabled}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!props.addButtonDisabled) {
              props.onAddButtonClick(e);
            }
          }}
        >
          <i className={'dcg-icon-plus'} />
          {UILocale.getString('dynamic.bundles.add')}
        </button>
      </span>
    </article>
  );

};

Product.propTypes = {
  sProductId: PropTypes.string.isRequired,
  sLabel: PropTypes.string.isRequired,
  sFullLabel: PropTypes.string.isRequired,
  sImageUrl: PropTypes.string.isRequired,
  sImageBigUrl: PropTypes.string.isRequired,
  sComplementaryLabel: PropTypes.string,
  sDescription: PropTypes.string.isRequired,
  fSeparatePrice: PropTypes.number.isRequired,
  bIsAvailable: PropTypes.bool.isRequired,
  bContainsSHD: PropTypes.bool.isRequired,
  bIsSHD: PropTypes.bool.isRequired,
  canBeHomeDelivered: PropTypes.bool.isRequired,
  isFV: PropTypes.bool.isRequired,
  canBeDownloaded: PropTypes.bool.isRequired,
  canBeReservedandCollected: PropTypes.bool.isRequired,
  canBePayedAndCollected: PropTypes.bool.isRequired,
  isForwardOrderable: PropTypes.bool.isRequired,
  isPreOrderable: PropTypes.bool.isRequired,
  bIsDiscount: PropTypes.bool.isRequired,
  sPrice: PropTypes.string.isRequired,
  sSeparatePrice: PropTypes.string.isRequired,
  sDiscount: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  onAddButtonClick: PropTypes.func,
  addButtonDisabled: PropTypes.bool
};

Product.defaultProps = {
  sComplementaryLabel: '',
  isMobile: false,
  onAddButtonClick: () => {},
  addButtonDisabled: false
};

export default Product;
